import React, { Component } from "react";
import { FormGroup, FormControl } from "react-bootstrap";

// import "../css/createTopic.css";
import { invokeApig } from "../../libs/awsLib";
import {API} from "aws-amplify";

//S3
import { s3ThumbnailUpload } from "../../libs/awsLib";

//Textfield
import TextField from 'material-ui/TextField';
import { TextValidator, ValidatorForm, SelectValidator } from 'react-material-ui-form-validator';

//Button
import LoaderButton from "../../components/LoaderButton";

//Checkbox
import Checkbox from 'material-ui/Checkbox';


//drop down field
import MenuItem from 'material-ui/MenuItem';

//Style
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import Paper from '@material-ui/core/Paper';

const styles = {
  container: {
    textAlign: 'center',
  },
  component: {
    margin: '60px 20px',
  },
  header:{
    marginLeft:20,
     marginTop:40,
     fontSize: 32,
     marginBottom:40
     },
     fields:{
      marginLeft: 20
    }
};
export default class createTopic extends Component {

  
  // //checkbox status
  state = {
    checkedSDG1: false,
    checkedSDG2: false,
    checkedSDG3: false,
    checkedSDG4: false,
    checkedSDG5: false,
    checkedSDG6: false,
    checkedSDG7: false,
    checkedSDG8: false,
    checkedSDG9: false,
    checkedSDG10: false,
    checkedSDG11: false,
    checkedSDG12: false,
    checkedSDG13: false,
    checkedSDG14: false,
    checkedSDG15: false,
    checkedSDG16: false,
    checkedSDG17: false,
    };

  constructor(props) {
    super(props);

    this.imageFile = null;

    this.state = {
      content:"",
      categories: [],
      topic: "",
      category:"",
      title:"",
      description:"",
      imageFile:"",
      SDG1: false,
      SDG2: false,
      SDG3: false,
      SDG4: false,
      SDG5: false,
      SDG6: false,
      SDG7: false,
      SDG8: false,
      SDG9: false,
      SDG10: false,
      SDG11: false,
      SDG12: false,
      SDG13: false,
      SDG14: false,
      SDG15: false,
      SDG16: false,
      SDG17: false,
      submitted: false,   
    };
    this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
  }


  //Make GET request to get the list of categories
  async componentDidMount() {
  
    try {
      const categories = await this.getCategory();
      this.setState({ categories });

    } catch (e) {
      alert(e);
    }
  
    this.setState({ submitted: false });
  }

   // make call to API to get Category for dropdown list
   getCategory() {
    return API.get("category", "/category");
  }


  handleSubmit = async event => {
        event.preventDefault();
     
        this.setState({ submitted: true });
        
        if(this.state.description.length<=0)
        {
          this.state.description = " ";
        }

        // if(this.state.imageFile.length <= 0)
        // {
        //   this.state.image = " " ;
        // }

        if (this.imageFile ==null) {
          alert(`Please upload a image Thumbnail file.`);
          this.setState({ submitted: false });
          return;
        }
       const attachment= this.imageFile
        ? await s3ThumbnailUpload( this.imageFile)
        : null;

        try {
          await this.createTopic({
            attachment,
            topic:this.state.topic,
            title: this.state.title,
            description: this.state.description,
            category: this.state.category,
            SDG1: this.state.checkedSDG1? 'Yes':'No',
            SDG2:  this.state.checkedSDG2? 'Yes':'No',
            SDG3:  this.state.checkedSDG3? 'Yes':'No',
            SDG4:  this.state.checkedSDG4? 'Yes':'No',
            SDG5:  this.state.checkedSDG5? 'Yes':'No',
            SDG6:  this.state.checkedSDG6? 'Yes':'No',
            SDG7:  this.state.checkedSDG7? 'Yes':'No',
            SDG8:  this.state.checkedSDG8? 'Yes':'No',
            SDG9:  this.state.checkedSDG9? 'Yes':'No',
            SDG10:  this.state.checkedSDG10? 'Yes':'No',
            SDG11:  this.state.checkedSDG11? 'Yes':'No',
            SDG12:  this.state.checkedSDG12? 'Yes':'No',
            SDG13:  this.state.checkedSDG13? 'Yes':'No',
            SDG14:  this.state.checkedSDG14? 'Yes':'No',
            SDG15:  this.state.checkedSDG15? 'Yes':'No',
            SDG16:  this.state.checkedSDG16? 'Yes':'No',
            SDG17:  this.state.checkedSDG17? 'Yes':'No',
            image:  this.state.imageFile
          });
          this.props.history.push("/topics");
        } catch (e) {
          alert(e);
          this.setState({ submitted: false });
        }
  }
  
  //call create topic API
  createTopic(topic) {
    // return API.post("topic", "/topic", {
    //   body: topic
    // });
  
    return invokeApig({
      path: "/topic",
      method: "POST",
      body: topic
    });
  }

  // Thumbnail image file Change
  handleFileChange = event => {
    this.imageFile = event.target.files[0];
    this.setState({imageFile:this.imageFile.name});

    }
  

  //Checkbox Change
  handleCheckBoxChange = name => event => {
    this.setState({ [name]: event.target.checked });

  };

   //Validate Form

   handleTextFieldChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };


  // Category Dropdown Menu change
  handleCategoryFieldChange = (event, index, category) => this.setState({category});


  selectionRenderer = (categories) => {
    switch (categories.length) {
      case 0:
        return '';
      case 1:
        return categories;
      default:
        return categories;
    }
  }

  menuItems(categories) {
    return categories.map((cat) => (
      <MenuItem
        key={cat.name}
        insetChildren={true}
        checked={this.state.categories.indexOf(cat.name) > -1}
        value={cat.name}
        primaryText={cat.name}
      />
    ));
  }

  render() {

    return (

        <Paper>
         <FormLabel style={styles.header}>Add New Topic</FormLabel>
       <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
            >  
              <Grid container spacing={24}>

              <Grid item xs={12} sm={6}>

                <TextValidator
                  name="topic"
                  floatingLabelText="Topic"
                  value={this.state.topic}
                  validators={['required']}
                  onChange={this.handleTextFieldChange("topic")}
                  errorMessages={['this field is required']}
                  style={styles.fields}
                  // margin="normal"
                  /> </Grid>
              
              <Grid item xs={12} sm={6}>
              <TextValidator
                  name="title"
                  floatingLabelText="Title"
                  value={this.state.title}
                  validators={['required']}
                  onChange={this.handleTextFieldChange("title")}
                  errorMessages={['this field is required']}
                  style={styles.fields}
                /></Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                   id="description"
                   floatingLabelText="Description"
                  value={this.state.description}
                  onChange={this.handleTextFieldChange("description")}
                  style={styles.fields}                  
                /></Grid><br />

              <Grid item xs={12} sm={6}>
              <SelectValidator
                  floatingLabelText="Category"
                  name= "category"
                  autoWidth={true}
                  value={this.state.category}
                  onChange={this.handleCategoryFieldChange}
                  validators={['required']}
                  errorMessages={['this field is required']}
                  selectionRenderer={this.selectionRenderer}
                  style={styles.fields}>
                  {this.menuItems(this.state.categories)}
                </SelectValidator></Grid><br />

                 <Grid item xs={12} sm={2}>

                <Checkbox
                    label="SDG1"
                    checked={this.state.checkedSDG1}
                    onCheck={this.handleCheckBoxChange('checkedSDG1')}
                    value="checkedSDG1"
                    style={styles.fields}
                  />
                  <Checkbox
                    label="SDG2"
                    checked={this.state.checkedSDG2}
                    onCheck={this.handleCheckBoxChange('checkedSDG2')}
                    value="checkedSDG2"
                    style={styles.fields}
                  />
                    <Checkbox
                    label="SDG3"
                    checked={this.state.checkedSDG3}
                    onCheck={this.handleCheckBoxChange('checkedSDG3')}
                    value="checkedSDG3"
                    style={styles.fields}
                  />
                    <Checkbox
                    label="SDG4"
                    checked={this.state.checkedSDG4}
                    onCheck={this.handleCheckBoxChange('checkedSDG4')}
                    value="checkedSDG4"
                    style={styles.fields}
                  /></Grid>

                  <Grid item xs={12} sm={2}>

                    <Checkbox
                    label="SDG5"
                    checked={this.state.checkedSDG5}
                    onCheck={this.handleCheckBoxChange('checkedSDG5')}
                    value="checkedSDG5"
                  />
                    <Checkbox
                    label="SDG6"
                    checked={this.state.checkedSDG6}
                    onCheck={this.handleCheckBoxChange('checkedSDG6')}
                    value="checkedSDG6"
                  />
                    <Checkbox
                    label="SDG7"
                    checked={this.state.checkedSDG7}
                    onCheck={this.handleCheckBoxChange('checkedSDG7')}
                    value="checkedSDG7"
                  />
                    <Checkbox
                    label="SDG8"
                    checked={this.state.checkedSDG8}
                    onCheck={this.handleCheckBoxChange('checkedSDG8')}
                    value="checkedSDG8"
                  /></Grid>

                  <Grid item xs={12} sm={2}>
            
                    <Checkbox
                    label="SDG9"
                    checked={this.state.checkedSDG9}
                    onCheck={this.handleCheckBoxChange('checkedSDG9')}
                    value="checkedSDG9"
                  />
                  <Checkbox
                    label="SDG10"
                    checked={this.state.checkedSDG10}
                    onCheck={this.handleCheckBoxChange('checkedSDG10')}
                    value="checkedSDG10"
                  />
                  <Checkbox
                    label="SDG11"
                    checked={this.state.checkedSDG11}
                    onCheck={this.handleCheckBoxChange('checkedSDG11')}
                    value="checkedSDG11"
                  />
                  <Checkbox
                    label="SDG12"
                    checked={this.state.checkedSDG12}
                    onCheck={this.handleCheckBoxChange('checkedSDG12')}
                    value="checkedSDG12"
                  /></Grid> 

                    <Grid item xs={12} sm={2}>

                    <Checkbox
                    label="SDG13"
                    checked={this.state.checkedSDG13}
                    onCheck={this.handleCheckBoxChange('checkedSDG13')}
                    value="checkedSDG13"
                  />
                  <Checkbox
                    label="SDG14"
                    checked={this.state.checkedSDG14}
                    onCheck={this.handleCheckBoxChange('checkedSDG14')}
                    value="checkedSDG14"
                  />
                  <Checkbox
                    label="SDG15"
                    checked={this.state.checkedSDG15}
                    onCheck={this.handleCheckBoxChange('checkedSDG15')}
                    value="checkedSDG15"
                  />

                  <Checkbox
                    label="SDG16"
                    checked={this.state.checkedSDG16}
                    onCheck={this.handleCheckBoxChange('checkedSDG16')}
                    value="checkedSDG16"/> 
                  </Grid>   

                  <Grid item xs={12} sm={2}>
            
                  <Checkbox
                  label="SDG17"
                  checked={this.state.checkedSDG17}
                  onCheck={this.handleCheckBoxChange('checkedSDG17')}
                  value="checkedSDG17"/>
                  </Grid> 

                 
                 <Grid item xs={12} sm={8}>

                    <FormGroup controlId="file">
                      <FormLabel style={styles.fields}>Upload Thumbnail Image </FormLabel>
                      <FormControl style={styles.fields} onChange={this.handleFileChange} type="file" />
                    </FormGroup>
                </Grid>

                    <LoaderButton
                      block
                      bsStyle="primary"
                      bsSize="large"
                      type="submit"
                      isLoading={this.state.submitted}
                      text="Create"
                      loadingText="Creating…"
                    />
          </Grid>


      </ValidatorForm>
</Paper>
    );
  }
}